import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import AnonSaveSlip from '../../../containers/modals/AnonSaveSlip';
import CancelCard from '../../../containers/modals/CancelCard';
import CancelWithdrawal from '../../../containers/modals/CancelWithdrawal';
import CardCanceled from '../../../containers/modals/CardCanceled';
import CardNumberRegistered from '../../../containers/modals/CardNumberRegistered';
import CashInConfirm from '../../../containers/modals/CashInConfirm';
import CashInFailure from '../../../containers/modals/CashInFailure';
import CashInInfo from '../../../containers/modals/CashInInfo';
import CashInPending from '../../../containers/modals/CashInPending';
import CompleteYourBet from '../../../containers/modals/CompleteYourBet';
import ConfirmCardNumber from '../../../containers/modals/ConfirmCardNumber';
import ConfirmPhoneNumber from '../../../containers/modals/ConfirmPhoneNumber';
import ConfirmTerms from '../../../containers/modals/ConfirmTerms';
import LinkAccountTerms from '../../../containers/modals/LinkAccountTerms';
import LogoutAnonymousUserConfirm from '../../../containers/modals/LogoutAnonymousUserConfirm';
import MobileNumberChanged from '../../../containers/modals/MobileNumberChanged';
import MobileNumberConfirmation from '../../../containers/modals/MobileNumberConfirmation';
import OnlineLogin from '../../../containers/modals/OnlineLogin';
import OnlineLoginTerms from '../../../containers/modals/OnlineLoginTerms';
import PhoneAlreadyRegistered from '../../../containers/modals/PhoneAlreadyRegistered';
import PromotionTerms from '../../../containers/modals/PromotionTerms';
import ResendConfirmationMessage from '../../../containers/modals/ResendConfirmationMessage';
import SavedSlipsLimitReached from '../../../containers/modals/SavedSlipsLimitReached';
import ShopIdConfirm from '../../../containers/modals/ShopIdConfirm';
import ShopIdNotFound from '../../../containers/modals/ShopIdNotFound';
import SlipDeleteConfirmationModal from '../../../containers/modals/SlipDeleteConfirmationModal';
import SlipNotSettled from '../../../containers/modals/SlipNotSettled';
import SlipTransferConfirm from '../../../containers/modals/SlipTransferConfirm';
import TransferInfo from '../../../containers/modals/TransferInfo';
import WithdrawalInfo from '../../../containers/modals/WithdrawalInfo';
import Empty from '../../modals/Empty';
import RequestInProgress from '../../modals/RequestInProgress';

const modalComponents = {
  AnonSaveSlip,
  CancelCard,
  CancelWithdrawal,
  CardCanceled,
  CardNumberRegistered,
  CashInConfirm,
  CashInFailure,
  CashInInfo,
  CashInPending,
  CompleteYourBet,
  ConfirmCardNumber,
  ConfirmPhoneNumber,
  ConfirmTerms,
  LinkAccountTerms,
  LogoutAnonymousUserConfirm,
  MobileNumberChanged,
  MobileNumberConfirmation,
  OnlineLogin,
  OnlineLoginTerms,
  PhoneAlreadyRegistered,
  PromotionTerms,
  ResendConfirmationMessage,
  SavedSlipsLimitReached,
  ShopIdConfirm,
  ShopIdNotFound,
  SlipDeleteConfirmationModal,
  SlipNotSettled,
  SlipTransferConfirm,
  TransferInfo,
  WithdrawalInfo,
  Empty,
  RequestInProgress
};

const wideModals = [
  'ConfirmTerms'
];

const ModalDialog = ({ name, params }) => {
  const component = modalComponents[name];

  if (!component) {
    return <div />;
  }

  const className = classNames('modal-dialog', {
    'modal-dialog--wide': wideModals.includes(name)
  });

  return (
    <div className={className}>
      <div className="modal-dialog__overlay" />
      <div className="modal-dialog__content">
        {React.createElement(component, params)}
      </div>
    </div>
  );
};

ModalDialog.propTypes = {
  name: PropTypes.string,
  params: PropTypes.object
};

ModalDialog.defaultProps = {
  params: {}
};

export default ModalDialog;
